"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = ({
  className
}) => {
  return _react.default.createElement(_SvgIcon.default, {
    className: className
  }, _react.default.createElement("path", {
    d: "M8.99242 9.366V8.619H3.84442V9.366H6.01342V15H6.83242V9.366H8.99242ZM14.6455 15L12.4225 11.139L14.6365 8.619H13.6465L10.7755 11.895V8.619H9.96547V15H10.7755V13.02L11.8555 11.787L13.7005 15H14.6455ZM19.5245 13.29C19.5245 12.642 19.1465 11.985 18.4805 11.76C18.9935 11.544 19.3985 10.932 19.3985 10.347C19.3985 9.807 19.2095 9.411 18.8945 9.123C18.5615 8.808 18.0575 8.619 17.5355 8.619C16.9955 8.619 16.5185 8.781 16.1675 9.069C15.7985 9.375 15.5735 9.825 15.5645 10.446H16.3475C16.3565 10.068 16.4825 9.762 16.7255 9.564C16.9145 9.411 17.1755 9.312 17.5175 9.312C17.8595 9.312 18.1385 9.447 18.3095 9.618C18.5075 9.807 18.6065 10.059 18.6065 10.347C18.6065 11.004 18.1475 11.4 17.4275 11.4H17.0225V12.111H17.4275C18.1925 12.111 18.7415 12.507 18.7415 13.272C18.7415 13.614 18.6155 13.875 18.4445 14.064C18.2285 14.307 17.8865 14.424 17.5085 14.424C17.1125 14.424 16.8155 14.28 16.6265 14.073C16.4195 13.857 16.3205 13.56 16.3025 13.209H15.5195C15.5285 13.785 15.7265 14.226 16.0505 14.55C16.4015 14.901 16.9055 15.117 17.5085 15.117C18.2105 15.117 18.7145 14.901 19.0475 14.55C19.3535 14.226 19.5245 13.776 19.5245 13.29Z",
    fill: "black"
  }), _react.default.createElement("path", {
    d: "M1 1H23V-1H1V1ZM23 1V23H25V1H23ZM23 23H1V25H23V23ZM1 23V1H-1V23H1ZM1 23L1 23H-1C-1 24.1046 -0.104568 25 1 25V23ZM23 23L23 23V25C24.1046 25 25 24.1046 25 23H23ZM23 1L23 1H25C25 -0.10457 24.1046 -1 23 -1V1ZM1 -1C-0.10457 -1 -1 -0.104568 -1 1H1L1 1V-1Z",
    fill: "#999999"
  }));
};

exports.default = _default;
module.exports = exports.default;